import $ from 'jquery';

export function initBasics(smoother) {

    var menu = $('header');

    // Anchor links: scroll via ScrollSmoother instead of the native browser
    // jump. A native #hash jump moves the real scroll position but leaves
    // ScrollSmoother's transform behind, which desyncs the scrollbar, exposes
    // whitespace under the footer, and breaks the header-colour threshold.
    $(document).on('click', 'a[href*="#"]', function(e) {
        var href = $(this).attr('href') || '';
        var hashIndex = href.indexOf('#');
        if (hashIndex < 0) {
            return;
        }

        var hash = href.slice(hashIndex);
        if (hash === '#' || hash.length < 2) {
            return;
        }

        // Only handle in-page links (same path or hash-only links).
        var path = href.slice(0, hashIndex);
        if (path && path.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) {
            return;
        }

        var target = document.getElementById(hash.slice(1));
        if (!target) {
            return;
        }

        e.preventDefault();

        if (smoother) {
            smoother.scrollTo(target, true, 'top top');
        } else {
            target.scrollIntoView();
        }

        // Keep the URL hash in sync without triggering a native jump.
        if (history.replaceState) {
            history.replaceState(null, '', hash);
        }
    });
    
    $('.toggle-menu').click(function(e){
        $('body').toggleClass('show-mobile-menu');
    });

    /* Mobile menu */
    $('header #mobile-menu li.menu-item-has-children').on('click', function(event){
        if ($(event.target).closest('a').length) {

        } else {
            $(this).toggleClass("open");
        }
    });

    $('div.dropdown a.nav-link').on('touchstart', function (e) {
        'use strict'; //satisfy code inspectors
        var link = $(this); //preselect the link
        if (link.hasClass('taphover')) {
            return true;
        } else {
            link.addClass('taphover');
            $('div.dropdown a').not(this).removeClass('taphover');
            e.preventDefault();
            return false; //extra, and to make sure the function has consistent return points
        }
    });

    $('body').on('touchstart', function(e){
        var touch = $(this);
        $('.taphover').removeClass('taphover');
    });

    // Function On Scroll
    $(window).scroll(function() {
        checkMenu(200);
    });
    checkMenu();

    // Make Menu Sticky
    function checkMenu(){

        var $first = $('section').first();

        // Add BG when first section has class 'menu-color'
        if ($first.hasClass('menu-color')) {
            $(menu).addClass('color');
            return;
        }

        // Add Color when scrolled through the first section (the hero).
        // Threshold = hero height minus header height, so the colour appears
        // once the hero has scrolled (almost) behind the header.
        var headerH = $('#masthead').outerHeight() || 0;
        var heroH   = $first.length ? $first.outerHeight() : 0;
        var threshold = Math.max(0, heroH - headerH);

        // Guarantee the threshold is reachable: on pages with little content
        // below the hero the scroll position can never reach heroH - headerH,
        // which previously left the menu transparent forever. Cap it to the
        // maximum scrollable distance so the background always kicks in.
        var maxScroll = Math.max(0, $(document).height() - $(window).height());
        threshold = Math.min(threshold, Math.max(0, maxScroll - 1));

        if (window.scrollY > threshold) {
            $(menu).addClass('color');
        } else {
            $(menu).removeClass('color');
        }
    }

    // Open Forms
    $('.open-form').click(function(e){
        e.preventDefault();
        var form = $(e.target).data('form');
        $('body').attr('data-form', form);
        $('sidebar#' + form).addClass('active');
    });

    // Close Forms
    $('.close-form, sidebar .overlay').click(function(){
        $('body').data('form', '');
        $('sidebar').removeClass('active');
    });
    $(document).on('keyup', function(e) {
        if (e.key == "Escape") {
            $('body').data('form', '');
            $('sidebar').removeClass('active');
        }
    });

    /* Explanation - Fold outs */
    jQuery('.explanation-question').on('click', function(){

        var content = jQuery(this).closest('li').find('.explanation-answer');
        var textWrapper = jQuery(this).closest('li').find('.explanation-answer-wrapper').first();

        if(jQuery(this).closest('li').first().hasClass('active')){
            jQuery(this).closest('li').first().removeClass('active');
            jQuery(content).css('height', '0');
        } else {
            jQuery(this).closest('li').first().addClass('active');
            jQuery(content).css('height', jQuery(textWrapper).outerHeight() + 'px');
        }
    });
    // Set Height to 0 for fluent animation
    jQuery('.explanation-items .explanation-answer').css('height', '0');

    // Topbar Swiper
    var topbarSwiper = null;
    
    function initTopbarSwiper() {
        if(jQuery('.topbar-swiper').length && window.innerWidth < 992){
            if(!topbarSwiper) {
                topbarSwiper = new Swiper(".topbar-swiper", {
                    spaceBetween: 0,
                    slidesPerView: 1,
                    loop: true,
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: false,
                    },
                    speed: 700,
                    allowTouchMove: false,
                });
            }
        } else if(topbarSwiper && window.innerWidth >= 992) {
            topbarSwiper.destroy(true, true);
            topbarSwiper = null;
        }
    }
    
    // Initialize on load
    initTopbarSwiper();
    
    // Reinitialize on resize
    jQuery(window).on('resize', function() {
        initTopbarSwiper();
    });

    // Review Swiper
    if(jQuery('.review-swiper').length){
        var reviewSwiper = new Swiper(".review-swiper", {
            spaceBetween: 32,
            slidesPerView: 1.3,
            breakpoints: {
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 32,
                },
                1400: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                }
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }

    // Referenties Swiper
    if(jQuery('.referenties-swiper').length){
        var referentiesSwipers = document.getElementsByClassName('referenties-swiper');
        for(var i = 0; i < referentiesSwipers.length; i++){
            var referentiesSwiper = new Swiper(referentiesSwipers[i], {
                spaceBetween: 60,
                slidesPerView: 2.5,
                speed: 4000,
                loop: true,
                allowTouchMove: false,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                autoplay: {
                    delay: 0,
                },
                breakpoints: {
                    768: {
                      slidesPerView: 3.5,
                      spaceBetween: 24
                    },
                    992: {
                        slidesPerView: 4.5,
                        spaceBetween: 24
                    },
                    1200: {
                        slidesPerView: 5.5,
                        spaceBetween: 32
                    },
                    1600: {
                        slidesPerView: 6,
                        spaceBetween: 40
                    },
                }
            });
        }
    }

    function initButtonCharacterStagger() {
        const offsetIncrement = 0.01; // Transition offset increment in seconds
        const buttons = document.querySelectorAll('[data-button-animate-chars]');
      
        buttons.forEach(button => {
          const text = button.textContent; // Get the button's text content
          button.innerHTML = ''; // Clear the original content
      
          [...text].forEach((char, index) => {
            const span = document.createElement('span');
            span.textContent = char;
            span.style.transitionDelay = `${index * offsetIncrement}s`;
      
            // Handle spaces explicitly
            if (char === ' ') {
              span.style.whiteSpace = 'pre'; // Preserve space width
            }
      
            button.appendChild(span);
          });
        });
    }
    
    initButtonCharacterStagger();

    // Copy link action on single post share block.
    $(document).on('click', '.single-share-copy', function() {
        const button = $(this);
        const label = button.find('span').first();
        const url = button.data('copy-url');
        const originalText = label.text();

        if (!url) {
            return;
        }

        const showCopiedState = function() {
            label.text('Link gekopieerd');
            setTimeout(function() {
                label.text(originalText);
            }, 1800);
        };

        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(url).then(showCopiedState);
            return;
        }

        const helperInput = document.createElement('input');
        helperInput.value = url;
        document.body.appendChild(helperInput);
        helperInput.select();
        document.execCommand('copy');
        document.body.removeChild(helperInput);
        showCopiedState();
    });

}